// extracted by mini-css-extract-plugin
export var underlinedLink = "_sz-0";